import { useState, useEffect, useRef } from "react"

export default function DarkTheme({ style }) {
  const [isLightMode, setIsLightMode] = useState(() => {
    try {
      const saved = localStorage.getItem("theme")
      if (saved === "light") return true
      if (saved === "dark") return false
      return window.matchMedia("(prefers-color-scheme: light)").matches
    } catch {
      return false
    }
  })

  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState("")
  const isInitialMount = useRef(true)

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: light)")

    const handleChange = () => {
      const saved = localStorage.getItem("theme")
      if (!saved) {
        setIsLightMode(mediaQuery.matches)
      }
    }

    mediaQuery.addEventListener("change", handleChange)

    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  // Apply theme to DOM
  useEffect(() => {
    const theme = isLightMode ? "light" : "dark"
    document.documentElement.dataset.theme = theme
    localStorage.setItem("theme", theme)
  }, [isLightMode])

  // Show toast when user toggles theme
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return
    }

    const theme = isLightMode ? "light" : "dark"
    setToastMessage(`Switched to ${theme} mode ✔️`)
    setShowToast(true)

    const timer = setTimeout(() => setShowToast(false), 2000)
    return () => clearTimeout(timer)
  }, [isLightMode])

  const handleToggle = () => {
    setIsLightMode((prev) => !prev)
    localStorage.setItem("theme", !isLightMode ? "light" : "dark")
  }

  return (
    <>
      <div className="global-search-game-btn-icon" style={style}>
        <button onClick={handleToggle}>
          <img
            className="light-dark-mode-icon"
            src={
              isLightMode
                ? "/images/icon/FGH_ICON_SUN.webp"
                : "/images/icon/FGH_ICON_MOON.webp"
            }
            alt="Toggle theme"
          />
        </button>
      </div>

      {showToast && <div className="theme-toast">{toastMessage}</div>}
    </>
  )
}
